<div class="page-wide">
  <!-- Hotel Header -->
  <div class="hotel-header mt-4 d-flex flex-row justify-content-between">
    <div>
      <h1>{{property?.property?.name}}, {{property?.property?.city}}</h1>
      <div class="hotel-header-details mt-3 d-flex flex-column flex-sm-row">
        <!-- Phone -->
        <div class="phone">
          <span>
            <a [href]="'tel:' + (property?.property?.phoneAreacode ?  property?.property?.phoneAreacode : '') + property?.property?.phoneNumber">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>
              <ng-template [ngIf]="property?.property?.phoneAreacode">({{property?.property?.phoneAreacode}})</ng-template>
              {{property?.property?.phoneNumber}}
            </a>
          </span>
        </div>
        <!-- Separator -->
        <div class="dot-seperator d-none d-sm-block mx-2">·</div>
        <!-- Address -->
        <div class="address">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-map" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.5.5 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103M10 1.91l-4-.8v12.98l4 .8zm1 12.98 4-.8V1.11l-4 .8zm-6-.8V1.11l-4 .8v12.98z" />
          </svg>
          <a [routerLink]='"."' [fragment]="'location'">
            {{property?.property?.street}}, {{property?.property?.city}}, {{property?.property?.state}} {{property?.property.postalCode}}
          </a>
        </div>
      </div>
    </div>
    <!-- Ukraine Support Badge -->
    @if (property?.property?.optInForDonation) {
      <a href="https://www.patreon.com/HotelsSupportUkraine" target="_blank" class="text-black text-decoration-none">
        <div class="d-flex gap-3">
          <div class="h6 text-uppercase">Proudly<br /> Support<br /> Ukraine</div>
          <img src="/assets/svg/ukraine_support_flag.svg" height="60">
        </div>
      </a>
    }
  </div>

  <!-- Image Slider -->
  <div class="hotel-slider">
    <app-mosaic [slides]="slides"></app-mosaic>
  </div>

  <!-- Main Content -->
  <div class="hotel-container d-flex justify-content-between flex-column flex-sm-row">
    <!-- Left Column -->
    <div class="split-left">
      <!-- Description -->
      <div class="description" [innerHTML]="property?.property?.description"></div>
      <hr>
      <!-- Amenities -->
      <div class="amenities">
        <h2>Amenities</h2>
        <div class="amenity-wrapper d-flex" fxLayout="row wrap">
          <div class="amenity d-flex align-items-center" *ngFor="let amenity of property?.amenities">
            <div class="me-3" fxFlex="36px">
              <div class="amenity-icon" *ngIf="!amenity?.matIcon">
                <img [src]="'https://gw.faircloudpms.com/booking' + amenity?.logo" width="30" />
              </div>
              <div class="amenity-icon-mat" *ngIf="amenity?.matIcon">
                <span class="material-icons">{{amenity?.matIcon}}</span>
              </div>
            </div>
            <div class="amenity-title">{{amenity?.name}}</div>
          </div>
        </div>
      </div>
      <hr>
      <!-- Things to Know -->
      <div class="things-to-know">
        <h2>Things to know</h2>
        <div class="a-thing d-flex flex-column flex-md-row">
          <!-- Check-in Info -->
          <div class="w-50">
            <h3>Checkin & Checkout</h3>
            <p>{{property?.property?.checkinTime}} — {{property?.property?.checkoutTime}}</p>
            <ng-template [ngIf]="property?.property?.checkInEndTime && property?.property?.checkInEndTime != '24:00'">
              <h3>Check-in End Time</h3>
              {{property?.property?.checkInEndTime}}
            </ng-template>
            <h3 *ngIf="property?.property?.infoDetails">Other Details</h3>
            <p>{{property?.property?.infoDetails}}</p>
          </div>
          <!-- Cancellation Policy -->
          <div class="w-50" *ngIf="property?.property?.cancellationpolicy">
            <h3>Cancellation Policy</h3>
            <p>{{property?.property?.cancellationpolicy}}</p>
          </div>
        </div>
        <!-- Accessibility Info -->
        <div class="a-thing" fxLayout="row" fxLayoutGap="16px" *ngIf="property?.property?.handicapInstructions">
          <div class="flex-fill" fxFlex.xs>
            <h3>Accessibility Information</h3>
            <p>{{property?.property?.handicapInstructions}}</p>
            <br />
            <a *ngIf="property?.property?.phoneNumber" [href]="'tel:' + (property?.property?.phoneAreacode ?  property?.property?.phoneAreacode : '') + property?.property?.phoneNumber">
              <button type="button" class="btn btn-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                </svg>
                Call Hotel
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column - Booking Form -->
    <div class="split-right" fxLayout="row" fxLayoutAlign="end">
      <div>
        <div class="reserve-box">
          <div class="form-group">
            <label>Checkin / Checkout</label>
            <input type="text" ngxDaterangepickerMd class="date-picker" [(ngModel)]="selectedDateRange" [autoApply]="true" placeholder="Check-in &nbsp; &nbsp; &mdash; &nbsp; &nbsp; Check-out" />
          </div>
          <div class="form-group">
            <label>Adult / Children</label>
            <app-guests-capture (getAdults)="getAdults($event)" (getChildren)="getChildren($event)"></app-guests-capture>
          </div>
          <div class="d-grid gap-2">
            <button class="btn btn-primary" type="button" (click)="bookNow()">Book Now</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Room Types -->
<div class="rooms" *ngIf="roomTypes?.length">
  <div class="page-wide">
    <h2>Rooms to stay</h2>
    <div class="rooms-wrapper" fxLayout="row wrap" fxLayoutGap="3%" fxLayout.xs="column" fxLayoutGap.xs="30px">
      <div class="room" fxFlex="30%" *ngFor="let room of roomTypes">
        <div class="room-image" 
          [ngStyle]="{'background-image': 'url(&quot;' + (room?.roomTypeImages[0]?.imagePath ? assets_base + room?.roomTypeImages[0]?.imagePath : 'assets/images/bed-placeholder.png') + '&quot;)'}">
        </div>
        <div class="room-content">
          <div class="heading" fxLayout="row" fxLayoutAlign="space-between end">
            <h3>{{room?.type}}</h3>
          </div>
          <div class="description">{{room?.description}}</div>
          <a class="book-now" [href]="property?.property?.webUrl">
            <button type="button" class="btn btn-primary">Book Now</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Attractions -->
<div class="attractions" *ngIf="attractions?.length">
  <div class="page-wide">
    <h2>Attractions</h2>
    <div class="attractions-wrapper row" fxLayoutGap="2%" fxLayout.xs="column" fxLayoutGap.xs="30px">
      <div class="attraction col-4 p-2" *ngFor="let attraction of attractions">
        <div class="attraction-image" [ngStyle]="{'background-image': 'url(&quot;' + assets_base + attraction?.imagePath + '&quot;)'}"></div>
      </div>
    </div>
  </div>
</div>

<!-- Location & Map -->
<div class="page">
  <div id="location" class="location">
    <div class="address">
      {{property?.property?.street}}, {{property?.property?.city}}, {{property?.property?.state}} {{property?.property.postalCode}}
    </div>
  </div>
</div>

<div class="property-map position-relative" *ngIf="property?.property?.latitude && property?.property?.longitude">
  <google-map 
    [options]="googleMapOptions"
    [center]="{lat: property?.property?.latitude, lng: property?.property?.longitude}" 
    [zoom]="9" 
    width="100%">
    <map-marker 
      [position]="{lat: property?.property?.latitude, lng: property?.property?.longitude}"
      [options]="markerOptions">
    </map-marker>
  </google-map>

  <div class="map-overlay position-absolute z-1">
    <h4>{{property?.property?.name}}, {{property?.property?.city}}</h4>
    <div class="address">
      <a [routerLink]='"."' [fragment]="'location'">
        {{property?.property?.street}},<br /> 
        {{property?.property?.city}}, {{property?.property?.state}} {{property?.property.postalCode}}
      </a>
    </div>
    <div class="phone">
      <span>
        <a [href]="'tel:' + (property?.property?.phoneAreacode ?  property?.property?.phoneAreacode : '') + property?.property?.phoneNumber">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
          </svg>
          <ng-template [ngIf]="property?.property?.phoneAreacode">({{property?.property?.phoneAreacode}}) </ng-template>
          {{property?.property?.phoneNumber}}
        </a>
      </span>
    </div>
    <div class="d-grid gap-2">
      <button class="btn btn-primary" type="button" (click)="bookNow()">Book Now</button>
    </div>
  </div>
</div>

<app-contact-form [propertyId]="property?.property?.id"></app-contact-form>